import { CSSProperties } from 'react';
import styled, { css } from 'styled-components';
import { white } from 'styles/Colors';

export const StyledList = styled.div<{ padding: CSSProperties['padding'] }>`
  background: ${white};
  box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.12);
  padding: ${(props) => props.padding};
  position: absolute;
  right: 25px;
  z-index: 100;
`;

export const Arrow = styled.span<{ below: boolean }>`
  position: absolute;
  top: -10px;
  right: 44px;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 0 10px 10px 10px;
  border-color: transparent transparent ${white} transparent;
  ${(props) =>
    props.below &&
    css`
      bottom: -10px;
      top: auto;
      border-width: 10px 10px 0 10px;
      border-color: ${white} transparent transparent transparent;
    `}
`;
